
import React from 'react';
import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';

interface MonthHeaderProps {
  dateStr: string;
  sortedDates: string[];
}

const MonthHeader: React.FC<MonthHeaderProps> = ({ dateStr, sortedDates }) => {
  const date = parseISO(dateStr);
  const month = format(date, 'MMMM', { locale: fr });
  const year = format(date, 'yyyy');
  
  // Get the first and last day of the month that contains events
  const firstDate = parseISO(sortedDates[0]);
  const lastDate = parseISO(sortedDates[sortedDates.length - 1]);
  
  const dateRange = `${format(firstDate, 'dd MMM', { locale: fr })} - ${format(lastDate, 'dd MMM', { locale: fr })}`;
  
  return (
    <div className="mb-6">
      <h2 className="text-xl font-bold text-slate-800 capitalize">{month} {year}</h2>
      <p className="text-sm text-slate-500">{dateRange}</p>
    </div>
  );
};

export default MonthHeader;
